import React from 'react';
import { CnLayoutPage as UICnLayoutPage, } from '@/components/cn-layout/index';
const CnLayoutPage = (props) => {
    const { children } = props || {};
    return <UICnLayoutPage>{children}</UICnLayoutPage>;
};
CnLayoutPage.displayName = 'CnLayoutPage';
export default CnLayoutPage;
export { CnLayoutPage };
